// 5 MB max upload size
export const DEFAULT_UPLOAD_FILES_SIZE = 1024 * 1024 * 5;

export const FILE_TYPE_MAP = {
  PDF: 'application/pdf',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
  DOC: 'application/msword',
  XML: 'application/xml',
  CSV: 'text/csv',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  HEIC: 'image/heic',
};

export function convertToBytes(input: string): number {
  const units: { [key: string]: number } = {
    KB: 1024,
    MB: 1024 * 1024,
  };

  try {
    const regex = /^(\d+(\,\d+)?)\s*(KB|MB)$/i;
    const match = input.match(regex);

    if (!match) {
      throw new Error('Invalid input format. Use format like "500 KB" or "2 MB".');
    }

    const value = parseFloat(match[1]!);
    const unit = match[3]!.toUpperCase();

    if (!units[unit]) {
      throw new Error('Unknown unit. Supported units are KB, MB.');
    }

    return value * units[unit]!;
  } catch (error) {
    console.error(`Failed to parse "${input}" for filesize`, error);
    return DEFAULT_UPLOAD_FILES_SIZE;
  }
}
